import { render, staticRenderFns } from "./ORDsListTable.vue?vue&type=template&id=ed28ecb8&scoped=true&"
import script from "./ORDsListTable.vue?vue&type=script&lang=js&"
export * from "./ORDsListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed28ecb8",
  null
  
)

export default component.exports